<script setup>
import { reactive } from 'vue'
import SlideUpDown from 'vue-slide-up-down'
// import Popper from 'vue3-popper'
import PopperIcon from './PopperIcon.vue'

const state = reactive({
    open: false
})
</script>

<template>
    <li class="job-finder__list-item">
        <div class="title" :class="{ 'open': state.open }"
             @click="state.open = !state.open"
        >
            <div class="left">
                <div class="description">
                    <h6>
                        Montážnik vo výrobe - plat až 1 100 EUR! Vhodné aj pre ženy!
                    </h6>
                    <p class="text">
                        Manpower Group Slovensko s.r.o. Šamorín
                    </p>
                </div>
                <div class="list-icons">
                    <div class="icon-column">
                        <PopperIcon 
                            icon-src="/img/icons/bus.svg"
                            content="Doprava zdarma"
                            class="dark-popper-theme"
                            hover-color="#38C975"
                        />
                    </div>
                    <div class="icon-column">
                        <PopperIcon
                            icon-src="/img/icons/house.svg"
                            content="Ubytovanie zdarma"
                            class="dark-popper-theme"
                            hover-color="#3F97EF"
                        />
                    </div>
                    <div class="icon-column">
                        <PopperIcon 
                            icon-src="/img/icons/euro.svg"
                            content="Peniaze"
                            class="dark-popper-theme"
                            hover-color="#FF0101"
                        />
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="tags">
                    <div class="c-tag" style="color: #fff; background-color: #D62828;">
                        <img src="/img/icons/fire.svg" alt="">
                        Top ponuka
                    </div>
                    <div class="c-tag" style="color: #0C0C0C; background-color: #fff; border-color: #38C976;">
                        <img src="/img/icons/money.svg" alt="">
                        až 1 100 EUR
                    </div>
                </div>
                <div class="actions">
                    <a href="#">
                        <svg width="26px" height="26px">
                            <use href="/img/icons/icons.svg#viber"></use>
                        </svg>
                    </a>
                    <a href="#">
                        <svg width="21px" height="20px">
                            <use href="/img/icons/icons.svg#whatsapp"></use>
                        </svg>
                    </a>
                    <a href="#">
                        <svg width="19px" height="18px">
                            <use href="/img/icons/icons.svg#phone"></use>
                        </svg>
                    </a>
                </div>
                <button type="button">
                    <img src="/img/icons/angle-right.svg" alt="">
                </button>
            </div>
        </div>
        <slide-up-down :active="state.open" :duration="1000">
            <div class="content" v-if="state.open">
                <div class="content-left">
                    <!-- <div class="top-bar hidden-lg-up">
                        <div class="list-icons">
                            <div class="icon-column">
                                <Popper click arrow class="dark-popper-theme">
                                    <div class="icon">
                                        <img src="/img/icons/bus.svg" alt="">
                                    </div>
                                    <template #content>
                                        <div>Doprava zdarma</div>
                                    </template>
                                </Popper>
                            </div>
                            <div class="icon-column">
                                <Popper click arrow class="dark-popper-theme">
                                    <div class="icon">
                                        <img src="/img/icons/house.svg" alt="">
                                    </div>
                                    <template #content>
                                        <div>Ubytovanie zdarma</div>
                                    </template>
                                </Popper>
                            </div>
                            <div class="icon-column">
                                <Popper click arrow class="dark-popper-theme">
                                    <div class="icon">
                                        <img src="/img/icons/euro.svg" alt="">
                                    </div>
                                    <template #content>
                                        <div>Peniaze</div>
                                    </template>
                                </Popper>
                            </div>
                        </div>
                        <div class="actions">
                        <a href="#">
                            <svg width="26px" height="26px">
                                <use href="/img/icons/icons.svg#viber"></use>
                            </svg>
                        </a>
                        <a href="#">
                            <svg width="21px" height="20px">
                                <use href="/img/icons/icons.svg#whatsapp"></use>
                            </svg>
                        </a>
                        <a href="#">
                            <svg width="19px" height="18px">
                                <use href="/img/icons/icons.svg#phone"></use>
                            </svg>
                        </a>
                    </div>
                    </div> -->
                    <p>Jednoduchá práca v sklade / práca so skenerom!</p>
                    <ul>
                        <li>mesačný príplatok 10%</li>
                        <li>ubytovanie zabezpečené</li>
                        <li>možnosť čerpania pravidelných záloh</li>
                        <li>možnosť absolvovania kurzu VZV priamo vo firme a prestup na pozíciu vodiča VZV alebo vláčika</li>
                        <li>doprava zo širokého okolia ZDARMA (Vráble, Nové Zámky, Komárno, Topoľčany)</li>
                    </ul>
                    <ul>
                        <li>práca v sklade</li>
                        <li>práca v pohybe</li>
                        <li>práca so skenerom</li>
                        <li>prebaľovanie balenie súčiastok</li>
                        <li>kontrolovanie množstva materiálu</li>
                        <li>vychystávanie a príprava materiálu</li>
                    </ul>

                    <div class="box-info">
                        <p>
                            Pre túto pozíciu sa uhrádza nasledovná minimálna mzda: <br />
                            <strong>978 € základný plat</strong> + mesačný príplatok až <strong>10% + príplatky za nadčasy</strong> + stravné lístky € .
                        </p>
                        <a href="#" class="c-tag">
                            Viac info
                        </a>
                    </div>
                </div>
                <div class="content-right">
                    <figure>
                        <picture>
                            <img src="/img/team-1.png" loading="lazy" alt="">
                        </picture>
                    </figure>
                    <p><strong>Karina Vargová</strong></p>
                    <p><a href="tel:">+421948146782</a></p>
                    <p><a href="mailto:k.vargova@transfer-personal.sk">k.vargova@transfer-personal.sk</a></p>

                    <a href="#" class="map-link" target="_blank">
                        Zobraziť na mape
                    </a>

                    <button type="button" class="c-button c-button--primary">
                        Požiadať
                        <svg width="17px" height="18px">
                            <use href="/img/icons/icons.svg#btnArrow"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </slide-up-down>
    </li>
</template>
